import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

const XIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
)

// Full-size view of one job-note photo, opened from its thumbnail in the job
// activity timeline. The app has no lightbox and none is worth a dependency for
// a single image, so this reuses the same sbr modal chrome as the address map
// modal. "Open original" is kept as an escape hatch for a photo that is bigger
// than the viewport (zoom, download, rotate — the browser does it better).
const JobNotePhotoModal = ({ src, onClose }) => {
    const { t } = useTranslation()

    return (
        <Modal show={!!src} onHide={onClose} backdropClassName="level-2" contentClassName="sbr-modal" centered size="lg">
            <Modal.Body>
                <div className="sbr">
                    <div className="sbm-head">
                        <div className="htx">
                            <div className="ttl">{t('track.photo')}</div>
                            <div className="sub">{t('jobNotes.attachedToActivity')}</div>
                        </div>
                        <button type="button" className="x" onClick={onClose} aria-label={t('common.close')}><XIcon /></button>
                    </div>
                    {src &&
                        <div className="jact-photo-full">
                            <img src={src} alt={t('jobNotes.photoAlt')} />
                            <a href={src} target="_blank" rel="noreferrer">{t('jobNotes.openOriginal')}</a>
                        </div>
                    }
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default JobNotePhotoModal
